export const deserialize = ({ position, ...node }) => {
  return { ...node, children: [{ text: '' }] };
};

export const serialize = ({ type }) => ({
  type,
});
